import $ from 'jquery';

const resize = ($container) => {
  $('[data-product-images-placeholder]', $container).height($('.ProductImages__carousel--active', $container).height());
  
  // Only set the dots placeholder height if the dots are being shown (not a "single" carousel)
  if ($('.ProductImages__carousel--active', $container).hasClass('ProductImages__carousel--single')) {
    $('[data-product-images-dots-placeholder]', $container).height(0);
  } else {
    $('[data-product-images-dots-placeholder]', $container).css('height', '');
  }

  // Only set the thumbs placeholder height if the thumbs are being shown (not empty)
  if ($('.ProductImages__thumbs--active', $container).hasClass('ProductImages__thumbs--empty')) {
    $('[data-product-images-thumbs-placeholder]', $container).height(0);
  } else {
    $('[data-product-images-thumbs-placeholder]', $container).height($('[data-product-images-thumbs]', $container).height());
  }
};

export default function() {
  $(window).on('resize', () => {
    resize($('[data-section-id="INF-ProductOverview"]'));
    resize($('[data-section-id="QuickView"]'));
  });
}